// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".codeBtn[data-v-cbbefe04] {\n  width: 85px;\n  margin-left: 25px;\n}\n.codeBtn > span[data-v-cbbefe04] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n.tips[data-v-cbbefe04] {\n  margin-bottom: 5px;\n  color: #f59a23;\n  padding: 5px 10px;\n  background: rgb(255, 245, 235);\n  font-size: 12px;\n}", ""]);
// Exports
module.exports = exports;
